import { render, staticRenderFns } from "./CustomToolset.vue?vue&type=template&id=57a4bc0e&scoped=true"
import script from "./CustomToolset.vue?vue&type=script&lang=ts"
export * from "./CustomToolset.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./CustomToolset.vue?vue&type=style&index=0&id=57a4bc0e&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./CustomToolset.vue?vue&type=style&index=1&id=57a4bc0e&prod&lang=scss&scoped=true")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "57a4bc0e",
  null
  ,true
)

export default component.exports